import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Card, Stack } from "@mui/material";
import { useCallback, useEffect } from "react";
import { ButtonComponent, FormProviderComponent, TextFieldComponent } from "../../../../components/form";
import CustomMonthCalender from '../../../../components/calender/customMonthCalender';

const CalculatorFIlterMobileCalender = ({
    selectedDay, 
    numberOfDays, 
    activeDistance, 
    setMonth, 
    setDays, 
    setDistance, 
    moveNextStep,
    allowDistanceEdit
}) => {
    const formSchema = yup.object().shape({
        distance: yup.number().required('Distance is required').moreThan(0, 'Distance is required'),
        days: yup.number().required('Number of days is required').typeError('Invalid number of days').moreThan(0, 'Number of days should be greater than zero')
    });
        
    const defaultValues = {
        distance: 0,
        days: numberOfDays
    };
        
    const formMethods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: defaultValues
    });
        
    const {
        setValue,
        reset: reset,
        handleSubmit: handleSubmit,
        formState: { isSubmitting: isSubmitting },
        watch
    } = formMethods;
        
    const values = watch();

    useEffect(() => {
        setValue('days', numberOfDays);
    }, [numberOfDays]);

    useEffect(() => {
        setValue('distance', activeDistance);
    }, [activeDistance]);

    const onSubmit = handleSubmit(async(data) => {
        console.log(data);
        
        setDays(data.days);
        setDistance(data.distance);

        moveNextStep();
    });

    const setSelectedMonth = useCallback((value) => {
        setMonth(value);
    }, [values]);

    return (
        <>
            <Stack 
                direction='column'
                justifyContent='center'
                alignItems='center'
                sx={{
                    pt: 2,
                    pb: 3
                }}
                spacing={2}
            >
                <Card
                    elevation={5}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: {xs: '100%', sm: 'fit-content'}
                    }}
                >
                    <CustomMonthCalender
                        selectedValue={selectedDay}
                        onSelectMonth={setSelectedMonth}
                    />
                </Card>

                <Box sx={{width: '100%'}}>
                    <FormProviderComponent methods={formMethods} onSubmit={onSubmit}>
                        <TextFieldComponent 
                            name='distance'
                            label='Distance (Km) *'
                            fullWidth
                            disabled={!allowDistanceEdit}
                        />

                        <TextFieldComponent 
                            name='days'
                            label='Number of Days *'
                            fullWidth
                        />

                        <ButtonComponent 
                            label='Next'
                            fullWidth
                            type="submit"
                            disabled={!selectedDay || values.days <= 0}
                            sx={{
                                mt: 3
                            }}
                        />
                    </FormProviderComponent>
                </Box>
            </Stack>
        </>
    );
}

export default CalculatorFIlterMobileCalender;